module.exports = __webpack_public_path__ + "img/soft-grove-dining-2.11879226.jpeg";